/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MODULE_NAME_CODES } from '../../config/constants';
import { CommonService } from '../../shared/services/common.service';

@Component({
  selector: 'app-recently-viewed',
  templateUrl: './recently-viewed.component.html'
})
export class RecentlyViewedComponent implements OnInit {
  @Output() closeSlider: EventEmitter<any> = new EventEmitter();
  public card: any = {};
  public homeMetaData!: { modules: Array<any> };
  public menuObj: any = {};

  constructor(private commonService: CommonService) {
    const vm = this;
    const menuId = this.commonService.getMenuId('RCV');
    this.commonService.setHelpObj({
      header: this.getTranslationWithKey('RCV') || '',
      menuId: menuId,
      sections: [],
      lastSavedData: [],
      tools: [
        {
          icon: 'icon-edit',
          action: this.getTranslationWithKey('edit'),
          actionInfo: this.getTranslationWithKey('edit_info')
        },
        {
          icon: 'icon-share-2',
          action: this.getTranslationWithKey('share'),
          actionInfo: this.getTranslationWithKey('share_info')
        },
        {
          icon: 'icon-delete',
          action: this.getTranslationWithKey('delete'),
          actionInfo: this.getTranslationWithKey('delete_info')
        }
      ],
      relatedLinks: [
        {
          label: this.getTranslationWithKey('FLP'),
          url: '/fieldsupport/distributorList/default'
        },
        {
          label: this.getTranslationWithKey('GLY'),
          url: '/genealogyHome/genealogy/default'
        },
        {
          label: this.getTranslationWithKey('ALT'),
          url: '/compensationHome/compensationAnalytics/default'
        }
      ]
    });
    vm.card = {
      code: 'RVC',
      name: this.getTranslationWithKey('recently_viewed'),
      icon: 'icon-history',
      showCloseIcon: true,
      showSearchBox: false,
      filter: this.getTranslationWithKey('recently_viewed_filter'),
      filterVal: '',
      recentSort: true,
      noDataMsg: this.getTranslationWithKey('no_recently_viewed_data_message'),
      items: [
        {
          name: this.getTranslationWithKey('salesforce'),
          code: MODULE_NAME_CODES.Distributors,
          collapse: false,
          list: []
        },
        {
          name: this.getTranslationWithKey('lineage'),
          code: MODULE_NAME_CODES.Genealogies,
          collapse: false,
          list: []
        },
        {
          name: this.getTranslationWithKey('reports'),
          code: MODULE_NAME_CODES.Reports,
          collapse: false,
          list: []
        }
      ]
    };
  }

  ngOnInit() {
    this.homeMetaData = this.commonService.getHomeMetaDetails();
  }

  public getTranslationWithKey(key: string): string {
    return this.commonService.getTranslatedVal(key);
  }

  public closeSliderTriggered() {
    this.closeSlider.emit();
  }
}
